import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DefaultersPage from "./DefaultersPage";

export default {
  list: DefaultersPage,
  icon: WarningAmberIcon,
  label: "Defaulters",
  options: { label: "Defaulters" },
  name: "feeDefaulters",
};
